import { Button, ButtonLink } from "@/components/Buttons/index";
import modalStyles from "@/styles/Modal.module.scss";
import config from "@/lib/config";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function IdcSignUpModal(_ref) {
  let {
    onClickHandle
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: modalStyles.logout,
    children: [/*#__PURE__*/_jsx("p", {
      className: modalStyles.text,
      children: "My\u30B9\u30AB\u30D1\u30FC\uFF01ID\u3092\u304A\u6301\u3061\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F"
    }), /*#__PURE__*/_jsxs("p", {
      className: modalStyles.caption,
      children: ["My\u30B9\u30AB\u30D1\u30FC\uFF01ID\u3092\u304A\u6301\u3061\u306E\u65B9\u306FMy\u30B9\u30AB\u30D1\u30FC\uFF01\u304B\u3089\u4F1A\u54E1\u79FB\u884C\u3059\u308B\u3092\u304A\u9078\u3073\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u203B\u4EE5\u524D\u306E\u30DD\u30A4\u30F3\u30C8\u304C\u6D88\u5931\u3059\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002"]
    }), /*#__PURE__*/_jsxs("div", {
      className: modalStyles.loginButtons,
      children: [/*#__PURE__*/_jsxs(ButtonLink, {
        type: "button",
        fillColor: true,
        large: true,
        fillGray: true,
        borderGray: true,
        href: config.idc.mySkpCooperation,
        fontFixedLineHeight: true,
        children: ["My\u30B9\u30AB\u30D1\u30FC\uFF01\u304B\u3089", /*#__PURE__*/_jsx("br", {}), "\u4F1A\u54E1\u79FB\u884C\u3059\u308B"]
      }), /*#__PURE__*/_jsxs(Button, {
        type: "button",
        fillColor: true,
        fontFixedLineHeight: true,
        large: true,
        onClick: onClickHandle,
        children: ["\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BA", /*#__PURE__*/_jsx("br", {}), "\u4F1A\u54E1\u767B\u9332\u3078\u9032\u3080"]
      })]
    })]
  });
}